<svelte:options customElement={{
  tag: "feature-service",
  shadow:"none",
  props: {
    title: { type: "String" },
    text: { type: "String" },
    items: { type: "String" }
  }
}} />


<script>
  import { onMount } from 'svelte';
  // import { api } from "../utility/Fetch";
  const EditIcon = "/assets_default/icons/edit.svg"
  const ATMIcon = "/assets_default/icons/atm.svg"
  const BoxIcon = "/assets_default/icons/box.svg"
  const RecordIcon = "/assets_default/icons/record.svg"
  const CoverIcon = "/assets_default/icons/cover.svg"
  const WinkIcon = "/assets_default/icons/wink.svg"
  const CardIcon = "/assets_default/icons/card.svg"
  const RateIcon = "/assets_default/icons/interestrate.svg"
  const SendIcon = "/assets_default/icons/send_money.svg"
  const percentIcon = "/assets_default/icons/percent.svg"
  const u25Icon = "/assets_default/icons/z_discount.svg"
  const invoiceIcon = "/assets_default/icons/invoice.svg"
  const loanIcon = "/assets_default/icons/loan.svg"
  import SectionHead from "@ce/SectionHead.svelte"

  const typeItems = [
    { type: "open-account", url: "/open-account/", icon: EditIcon, alt: "ペンアイコン", label: "口座開設" },
    { type: "atm", url: "/service/atm/", icon: ATMIcon, alt: "ATMアイコン", label: "ATM" },
    { type: "box", url: "/service/box/", icon: BoxIcon, alt: "ボックスアイコン", label: "ボックス" },
    { type: "record", url: "/service/record/", icon: RecordIcon, alt: "レコードアイコン", label: "レコード" },
    { type: "cover", url: "/service/cover/", icon: CoverIcon, alt: "カバーアイコン", label: "カバー" },
    { type: "loan", url: "/service/loan/", icon: loanIcon, alt: "ローンアイコン", label: "ローン" },
    { type: "premium", url: "/service/premium/", icon: WinkIcon, alt: "ウィンクアイコン", label: "プレミアム<br>サービス" },
    { type: "debit-card", url: "/service/debit-card/", icon: CardIcon, alt: "カードアイコン", label: "デビット<br class=\"show:sp\">カード" },
    { type: "rates", url: "/rates/", icon: RateIcon, alt: "レートアイコン", label: "金利" },
    { type: "transfer", url: "/service/transfer/", icon: SendIcon, alt: "振り込みアイコン", label: "振込<br>ことら送金" },
    { type: "fees", url: "/fees/", icon: percentIcon, alt: "振り込みアイコン", label: "手数料" },
    { type: "u25", url: "/service/u25/", icon: u25Icon, alt: "U25アイコン", label: "U25 Z割" },
    { type: "invoice", url: "/service/invoice/", icon: invoiceIcon, alt: "請求書アイコン", label: "請求書払い" }
  ];

  const defaultItems = "open-account,atm,box,record,cover,premium";

  let {
    title = "おすすめサービス",
    text = "",
    items = defaultItems
  } = $props();
  let posts = $state([]);

  const custom = $derived.by(() => {
    if (items) {
      const targetTypes = items.split(',').map(s => s.trim());
      return targetTypes.map(type =>
        posts.find(post => post.type === type)//itemsの順番を維持
      ).filter(Boolean); // 見つからなかった要素を除外
    }
    return [];
  })

  async function fetchPosts() {
    try {
      posts = typeItems;
    } catch (e) {
      console.error("JSON parse error in items:", e);
    }
  }

  onMount(() => {
    fetchPosts();
  });
</script>
<section class="owd-section spacing:bottom:64">
  <SectionHead caption="SERVICE" title={title} text={text} ></SectionHead>
  <div class="owd-servicelist:wrapper bg-colors:light-gray spacing:bottom:32">
    <!-- <p class="align:center spacing:bottom:16 owd-heading:03">おすすめ機能</p> -->
    <ul class="owd-servicelist owd-servicelist:colmun:03 block:center">
      {#each custom as i}
      <li class="owd-servicelist-item">
        <a href="{i.url}" class="owd-servicelist-item-inner">
          <img class="owd-servicelist-icon" src={i.icon} alt="{i.alt}">
          <p class="owd-label align:center">{@html i.label}</p>
        </a>
      </li>
      {/each}
    </ul>
  </div>
  <div class="block:center">
    <a href="/service/" class="owd-button owd-button:large owd-button:secondary:white">サービス一覧を見る</a>
  </div>
</section>
